import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from "./components/footer/footer.component";
import { ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDialogModule } from '@angular/material/dialog';
import { CarouselModule } from '@coreui/angular';
import { TranslateService } from '@ngx-translate/core';
import { Title } from '@angular/platform-browser';
import { filter, map, mergeMap } from 'rxjs/operators';
import Cookies from 'js-cookie';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    HeaderComponent,
    FooterComponent,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatDialogModule,
    CarouselModule
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(
    private translate: TranslateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title
  ) { }

  ngOnInit(): void {
    this.translate.setDefaultLang('de');
    this.translate.use('de');

    //Listen to route changes and update the page title dynamically
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => {
          let route = this.activatedRoute.firstChild;
          while (route?.firstChild) {
            route = route.firstChild; 
          }
          return route;
        }),
        filter(route => !!route),
        mergeMap(route => route!.data) 
      )
      .subscribe(data => {
        if (data['title']) {
          this.translate.get(data['title']).subscribe(translatedTitle => {
            this.titleService.setTitle(translatedTitle);
          });
        }
      });
  }

  useLanguage(language: string): void {
    this.translate.use(language);

    //Update the page title when the language changes
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        mergeMap(() => this.activatedRoute.firstChild?.data || [])
      )
      .subscribe(data => {
        if (data?.['title']) {
          this.translate.get(data['title']).subscribe(translatedTitle => {
            this.titleService.setTitle(translatedTitle);
          });
        }
      });
  }
}
